import { createReducer } from "redux-create-reducer";

import {
  GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES,
  CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES,
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
  CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
  SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS,
  GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT,
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
} from "../types";

const initialState = {
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    minimumMatchingPercentage: null,
    watchListTypes: [],
    file: null,
  },
  entries: [],
  isLoading: false,
  noEntriesMessage: "",
};

const watchListMultipleSearchEntriesReducer = createReducer(initialState, {
  [SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS]: (state, { payload }) => {
    return { ...initialState, filters: { ...state.filters, ...payload } };
  },
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_COUNT.FULFILLED]: (
    state,
    { payload }
  ) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    entries: payload.data,
    isLoading: false,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),

  [CLEAR_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES]: () => initialState,

  [CHANGE_ITEMS_PER_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES]: (
    state,
    { payload }
  ) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [CHANGE_CURRENT_PAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES]: (
    state,
    { payload }
  ) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES]: (
    state,
    { payload }
  ) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
});

export default watchListMultipleSearchEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/watchListMultipleSearchEntriesReducer.js